import { useWhatsappCardForm } from "@/components/shared/forms/whatsapp-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddWhatsappCard(defaultType: "whatsapp1" | "whatsapp2", defaultColors: CommonColor) {
  const { formContent, previewContent, shuffleColors, toggleType, handleSubmit } = useWhatsappCardForm({
    initialData: {
      whatsappNumber: "",
      initialMessage: "",
      buttonText: "",
      title: "",
      description: "",
      type: defaultType,
      colors: defaultColors,
    },
    mode: "add",
  });

  return {
    formContent,
    previewContent,
    shuffleColors,
    toggleType,
    handleSubmit,
  };
}